import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=772b3162&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=772b3162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b3162",
  null
  
)

export default component.exports